// extracted by mini-css-extract-plugin
module.exports = {"plan":"planSelectionItem_plan__VYeQw","selectedPlan":"planSelectionItem_selectedPlan__XFnJY"};